// showToast.js
import { useToast } from "vue-toastification";
import moment from "moment";
import Swal from "sweetalert2";

export const showToast = (message, type, callback) => {
  const toast = useToast();
  const options = {
    position: "top-right",
    timeout: 2500,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
  };

  if (typeof callback === "function") {
    callback(options); // Invoke the callback function with the options object
  }

  switch (type) {
    case "success":
      toast.success(message, options);
      break;
    case "error":
      toast.error(message, options);
      break;
    case "warning":
      toast.warning(message, options);
      break;
    case "info":
      toast.info(message, options);
      break;
    default:
      toast.show(message, options);
  }
};

export const dateConvert = (date) => {
  const fecha = moment(date);
  const fechaFormateada = fecha.format("DD/MM/YYYY hh:mm A");
  return fechaFormateada;
};

const Confirmar = Swal.mixin({
  allowOutsideClick: false,
  showCancelButton: true,
  confirmButtonText: "Confirmar",
  cancelButtonText: "Cancelar",
  buttonsStyling: false,
  customClass: {
    confirmButton: "btn bg-gradient-primary me-2",
    cancelButton: "btn bg-gradient-danger",
  },
  //confirmButtonText: "<i class='fa fa-check mr-2'></i>Confirmar",
  //cancelButtonText: "<i class='fa fa-times mr-2'></i>Cancelar",
});

/* export const confirmDialog = ({
  icon: 'question',
  title: "¿Desea continuar?",
  text: "Esta acción no se podrá deshacer",
}) => {
  return Confirmar.fire({
    icon,
    title,
    text,
  });
};
 */

export const confirmDialog = ({
  icon = "question",
  title = "¿Desea continuar?",
  html = "Esta acción no se podrá deshacer",
} = {}) => {
  return Confirmar.fire({
    icon,
    title,
    html,
  });
};

export const exceptionRequestMsg = (e) => {
  if (e.response.status === 422 && e.response.data?.errors) {
    showToast(
      Object.values(e.response.data.errors)
        .map((value) => `・ ${value}`)
        .join("\n"),
      "error"
    );
  } else if (e.response.data?.message) {
    showToast(e.response.data?.message, "error");
  } else {
    console.log(e);
    showToast(`Error en la petición: ${e}`, "error");
  }
};
